var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#F3F3F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3248_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4489 21.6364C18.641 21.6364 18.8253 21.7127 18.9611 21.8486C19.097 21.9844 19.1733 22.1687 19.1733 22.3608C19.1733 22.5529 19.097 22.7372 18.9611 22.8731C18.8253 23.0089 18.641 23.0853 18.4489 23.0853H15.5511C15.359 23.0853 15.1747 23.0089 15.0389 22.8731C14.903 22.7372 14.8267 22.5529 14.8267 22.3608C14.8267 22.1687 14.903 21.9844 15.0389 21.8486C15.1747 21.7127 15.359 21.6364 15.5511 21.6364H18.4489ZM21.3466 16.8068C21.5387 16.8068 21.723 16.8832 21.8588 17.019C21.9947 17.1549 22.071 17.3391 22.071 17.5313C22.071 17.7234 21.9947 17.9077 21.8588 18.0435C21.723 18.1794 21.5387 18.2557 21.3466 18.2557H12.6534C12.4613 18.2557 12.277 18.1794 12.1412 18.0435C12.0053 17.9077 11.929 17.7234 11.929 17.5313C11.929 17.3391 12.0053 17.1549 12.1412 17.019C12.277 16.8832 12.4613 16.8068 12.6534 16.8068H21.3466ZM24.2443 11.9773C24.4364 11.9773 24.6207 12.0536 24.7566 12.1895C24.8924 12.3253 24.9688 12.5096 24.9688 12.7017C24.9688 12.8939 24.8924 13.0781 24.7566 13.214C24.6207 13.3498 24.4364 13.4262 24.2443 13.4262H9.75568C9.56355 13.4262 9.37929 13.3498 9.24343 13.214C9.10757 13.0781 9.03125 12.8939 9.03125 12.7017C9.03125 12.5096 9.10757 12.3253 9.24343 12.1895C9.37929 12.0536 9.56355 11.9773 9.75568 11.9773H24.2443Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3248_552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1818,
    height: 13.9091,
    fill: "white",
    transform: "translate(5.40918 10.0454)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.86bd36c7189daf4619972dad309fe79d.svg";
export { ForwardRef as ReactComponent };